module.exports = __webpack_public_path__ + "img/being-creative.2795ad2c.svg";